module.exports = __webpack_public_path__ + "static/media/01n.3077681e.svg";